const middleware = {}

middleware['allowNonMember'] = require('../src/middleware/allowNonMember.ts')
middleware['allowNonMember'] = middleware['allowNonMember'].default || middleware['allowNonMember']

middleware['applicationForm'] = require('../src/middleware/applicationForm.ts')
middleware['applicationForm'] = middleware['applicationForm'].default || middleware['applicationForm']

middleware['canAccessMemberApp'] = require('../src/middleware/canAccessMemberApp.ts')
middleware['canAccessMemberApp'] = middleware['canAccessMemberApp'].default || middleware['canAccessMemberApp']

middleware['featureFlagging'] = require('../src/middleware/featureFlagging.ts')
middleware['featureFlagging'] = middleware['featureFlagging'].default || middleware['featureFlagging']

middleware['fetchUser'] = require('../src/middleware/fetchUser.ts')
middleware['fetchUser'] = middleware['fetchUser'].default || middleware['fetchUser']

middleware['guestInvite'] = require('../src/middleware/guestInvite.ts')
middleware['guestInvite'] = middleware['guestInvite'].default || middleware['guestInvite']

middleware['hasBeenInducted'] = require('../src/middleware/hasBeenInducted.ts')
middleware['hasBeenInducted'] = middleware['hasBeenInducted'].default || middleware['hasBeenInducted']

middleware['hasVerifiedAccount'] = require('../src/middleware/hasVerifiedAccount.ts')
middleware['hasVerifiedAccount'] = middleware['hasVerifiedAccount'].default || middleware['hasVerifiedAccount']

middleware['initializer'] = require('../src/middleware/initializer.ts')
middleware['initializer'] = middleware['initializer'].default || middleware['initializer']

middleware['isAuthorized'] = require('../src/middleware/isAuthorized.ts')
middleware['isAuthorized'] = middleware['isAuthorized'].default || middleware['isAuthorized']

middleware['publicOnly'] = require('../src/middleware/publicOnly.ts')
middleware['publicOnly'] = middleware['publicOnly'].default || middleware['publicOnly']

export default middleware
